"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgUpload = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M33 28a1 1 0 011 1v3a3 3 0 01-3 3H17a3 3 0 01-3-3v-3a1 1 0 012 0v3a1 1 0 001 1h14a1 1 0 001-1v-3a1 1 0 011-1zm-9-15h.02c.023 0 .046.002.07.004L24 13a1.008 1.008 0 01.617.213l.008.007.082.073 4 4a1 1 0 01-1.414 1.414L25 16.414V28a1 1 0 01-2 0V16.414l-2.293 2.293a1 1 0 01-1.414-1.414l4-4 .082-.073.008-.007-.09.08a1.008 1.008 0 01.689-.293H24z",
    id: "upload_svg__a"
  }));
};

var _default = SvgUpload;
exports.default = _default;